/*
Copyright (c) 2016 Yang Liu <hi@zesik.com>

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

import * as React from 'react';

interface Props {
    vertical: boolean;
    primary: boolean;
    size: number;
    percentage: boolean;
    children: any;
}

class Pane extends React.Component<Props, any> {
    public static defaultProps = {
        vertical: false,
        primary: false,
        size: 0,
        percentage: false,
        children: []
    };

    render() {
        const size = this.props.size || 0;
        const unit = this.props.percentage ? '%' : 'px';
        let classes = 'layout-pane';
        const style: any = {};
        if (!this.props.primary) {
            if (this.props.vertical) {
                style.height = `${size}${unit}`;
            } else {
                style.width = `${size}${unit}`;
            }
        } else {
            classes += ' layout-pane-primary';
        }
        return (
            <div className={classes} style={style}>{this.props.children}</div>
        );
    }
}

export default Pane;
